import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import UserGuidePage from './pages/UserGuidePage';
import SoftphonePage from './pages/SoftphonePage';
import DemoPage from './pages/DemoPage';
import TermsPage from './pages/TermsPage';
import { Toaster } from './components/ui/sonner';

const ScrollToTop = () => {
  const { hash, pathname, search } = useLocation();

  React.useEffect(() => {
    const pageTitles = {
      '/': 'Context to Call | Connect with your customers',
      '/features': 'Features | Context to Call',
      '/user-guide': 'User Guide | Context to Call',
      '/softphone': 'C2C Softphone | Context to Call',
      '/demo': 'Product Demos | Context to Call',
      '/terms': 'Terms and Conditions | Context to Call',
    };

    document.title = pageTitles[pathname] || 'Context to Call';

    if (hash) {
      window.setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }, 0);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [hash, pathname, search]);

  return null;
};

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/user-guide" element={<UserGuidePage />} />
            <Route path="/softphone" element={<SoftphonePage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
